import React from 'react';
import styled from "styled-components";
import {ReactComponent as Icon} from '../assets/icons/iconmonstr-barcode-filled.svg'


const IconoBarCode = styled(Icon)`
height: 20px;
fill: #fff;
`


const IconBarCode = () => {
    return ( 
        <>
            <IconoBarCode></IconoBarCode>
        </>
     );
}
 
export default IconBarCode;